import React from 'react';
import CTA from './CTA';
import RedSocial from './redSocial';
import ME from '../../assets/me-1.png';
import './cabezaPagina.css';

const CabezaPagina = () => {
  return (
    <div className="container header__container">
      <h5 id='inicio'>Hola yo soy</h5>
      <h1>Bryan Coronado</h1>
      <h5 className="text-ligth">ingeniero de software</h5>
      <CTA />
      <RedSocial />

      <div className='me'>
        <img  src={ME} alt="me" />
      </div>

      <a href="#contacto" className='contacto_cabeza'>Scroll Down</a>
    </div>
  );
};

export default CabezaPagina;
